<template>
  <div class="col-12 col-md-12 col-lg-8 col-xl-6 mb-3">
    <div class="row gallery-row mb-2">
      <div class="col col-12 mb-2 d-none d-md-block">
        <img
          :src="images[selectedIndex]"
          class="img-fluid"
          alt=""
        >
      </div>
      <div
        v-for="(image, index) in images"
        :key="image + '_ ' + index"
        class="col col-12 col-sm-4 mb-2 gallery-image"
        @click="selectedIndex = index"
      >
        <img
          :src="image"
          class="img-fluid"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';

  @Component
  export default class TypeImages extends Vue {
    selectedIndex = 0;
    @Prop(Array) images


  }
</script>

<style scoped>
  .gallery-image {
    cursor: pointer;
  }
</style>
